<template>
  <div class="meridian-risks-page">
    <van-nav-bar
      title="经络隐患"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
      safe-area-inset-top
    />

    <div class="teal-bg">
      
      <!-- 解析说明卡片 -->
      <div class="card-container">
        <div class="card-header-center">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/解析说明.png" alt="解析说明" class="header-icon" />
          <span class="header-title">解析说明</span>
        </div>
        <div class="introduce-text">
          {{ introduce }}
        </div>
      </div>

      <!-- 经络图卡片 -->
      <div class="card-container">
        <div class="card-header-center">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/经络隐患.png" alt="经络图" class="header-icon" />
          <span class="header-title">经络图</span>
        </div>

        <!-- 中间的图表区域 -->
        <div class="chart-container" v-if="list && list.length > 0">
          <div class="chart-main">
            <div class="chart-row" v-for="(item, index) in list" :key="`chart-${index}`">
              <!-- 左侧序号 -->
              <div class="chart-y-label">{{ index + 1 }}</div>
              
              <div class="chart-tracks-wrapper">
                <!-- 实证轨道 (左侧) -->
                <div class="chart-left-track">
                  <div class="chart-bar green-bar" v-if="item.result === '实证'"></div>
                </div>
                <!-- 虚症轨道 (右侧) -->
                <div class="chart-right-track">
                  <div class="chart-bar orange-bar" v-if="item.result === '虚症' || item.result === '虚证'"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- 底部坐标说明 -->
          <div class="chart-x-axis">
            <div class="axis-half axis-half-left">
              <span class="axis-value">100</span>
              <span class="axis-label">实证</span>
            </div>
            <div class="axis-center">0</div>
            <div class="axis-half axis-half-right">
              <span class="axis-label">虚证</span>
              <span class="axis-value">100</span>
            </div>
          </div>
        </div>

        <!-- 新增：经络名称网格列表 -->
        <div class="meridian-name-section" v-if="list && list.length > 0">
          <div class="section-title">经络名称：</div>
          <div class="name-grid">
            <div class="name-tag" v-for="(item, index) in list" :key="`name-${index}`">
              {{ index + 1 }}. {{ item.name }}
            </div>
          </div>
        </div>
      </div>

      <!-- 经络症状卡片区 -->
      <div class="card-container" v-if="list && list.length > 0">
        <div class="card-header-center">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/经络隐患.png" alt="经络症状" class="header-icon" />
          <span class="header-title">经络症状</span>
        </div>

        <!-- 图文卡片列表 -->
        <div class="symptom-list">
          <div class="symptom-item" v-for="(item, index) in list" :key="`symptom-${index}`">
            <!-- 左侧固定图片 (如果有 img，则展示，否则用默认占位) -->
            <div class="symptom-img-wrapper">
              <img :src="item.img || defaultMeridianImg" class="symptom-img" />
            </div>
            <!-- 右侧信息 -->
            <div class="symptom-info">
              <div class="symptom-title">{{ item.name }}({{ item.result }})</div>
              <div class="symptom-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部声明与时间 -->
      <div class="bottom-statement">
        <div class="statement-text">
          重要声明：本报告采用AI人工智能分析总结，仅供参考，不可作为医疗诊断结论，如已有身体不适，请及时咨询医生。
        </div>
        <div class="time-text" v-if="createAt">
          生成时间：{{ formatTime(createAt) }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { NavBar } from 'vant';

export default {
  name: 'MyAiMeridianRisks',
  components: {
    [NavBar.name]: NavBar,
  },
  data() {
    return {
      introduce: '',
      list: [],
      createAt: '',
      // 如果数据中没有图片，提供一个默认图片
      defaultMeridianImg: 'https://uat-yeahgo-oss.yeahgo.com/wechat/scanBoot/default_meridian.png'
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    loadData() {
      const dataStr = sessionStorage.getItem("MY_AI_MERIDIAN_RISKS");
      if (dataStr) {
        try {
          const data = JSON.parse(dataStr);
          this.introduce = data.introduce || '';
          this.list = data.list || [];
          this.createAt = data.createAt || '';
        } catch (e) {
          console.error("解析经络隐患数据失败", e);
        }
      }
    },
    formatTime(timeStr) {
      if (!timeStr) return '';
      try {
        const parts = timeStr.split(' ');
        const dateParts = parts[0].split('-');
        return `${dateParts[0]}年${parseInt(dateParts[1], 10)}月${parseInt(dateParts[2], 10)}日 ${parts[1] || ''}`;
      } catch (e) {
        return timeStr;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.meridian-risks-page {
  background: #44C2C4;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  ::v-deep .van-nav-bar--fixed {
    z-index: 1000;
  }
}

.teal-bg {
  flex: 1;
  background: #44C2C4;
  padding: 16px 12px;
  position: relative;
  z-index: 0;
}

.card-container {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  margin-bottom: 16px;
}

.card-header-center {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.header-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

/* 解析说明 */
.introduce-text {
  background: #f7f8fa;
  padding: 16px;
  border-radius: 8px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: justify;
}

/* === 经络图表样式 === */
.chart-container {
  margin-top: 16px;
  padding-bottom: 8px;
  position: relative;
}

.chart-main {
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
}

.chart-main::after {
  content: "";
  position: absolute;
  left: calc(50% + 16px);
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #c37a2c;
  transform: translateX(-50%);
  z-index: 1;
}

.chart-row {
  display: flex;
  align-items: center;
  height: 18px;
}

.chart-y-label {
  width: 24px;
  text-align: center;
  font-size: 11px;
  color: #b97c2f;
  margin-right: 8px;
  flex-shrink: 0;
  font-weight: 400;
}

.chart-tracks-wrapper {
  flex: 1;
  display: flex;
  height: 100%;
  position: relative;
}

.chart-left-track {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 0; /* 让柱子紧贴中轴线 */
  position: relative;
  z-index: 2;
}

.chart-right-track {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 0; /* 让柱子紧贴中轴线 */
  position: relative;
  z-index: 2;
}

.chart-bar {
  height: 12px;
  width: 90%; 
}

.green-bar {
  background-color: #8ccd97;
  border-radius: 8px 0 0 8px;
}

.orange-bar {
  background-color: #ff5a00;
  border-radius: 0 8px 8px 0;
}

.chart-x-axis {
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: start;
  margin-left: 32px;
  padding-top: 10px;
}

.chart-x-axis::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 1px;
  background: #c37a2c;
}

.axis-half {
  position: relative;
  min-height: 22px;
  font-size: 9px;
  color: #b97c2f;
  font-weight: 400;
}

.axis-half-left {
  padding-right: 10px;
}

.axis-half-right {
  padding-left: 10px;
}

.axis-value {
  position: absolute;
  top: 0;
}

.axis-half-left .axis-value {
  left: 0;
}

.axis-half-right .axis-value {
  right: 0;
}

.axis-label {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.axis-center {
  min-width: 20px;
  text-align: center;
  font-size: 9px;
  color: #b97c2f;
  font-weight: 400;
  line-height: 22px;
}

/* === 经络名称网格样式 === */
.meridian-name-section {
  margin-top: 16px;
  padding-top: 16px;
}

.section-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
}

.name-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.name-tag {
  background: #f7f8fa;
  border-radius: 6px;
  padding: 8px 4px;
  font-size: 12px;
  color: #333;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* === 经络症状卡片区样式 === */
.symptom-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.symptom-item {
  display: flex;
  background: #f7f8fa;
  border-radius: 8px;
  padding: 16px;
  gap: 16px;
}

.symptom-img-wrapper {
  width: 96px;
  height: 128px;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  flex-shrink: 0;
  border: 1px solid #eee;
}

.symptom-img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 或者 cover 取决于您的图片比例 */
}

.symptom-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.symptom-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.symptom-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  text-align: justify;
}

/* === 底部声明与时间 === */
.bottom-statement {
  padding: 16px 12px;
  margin-top: 8px;
}

.statement-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  text-align: justify;
}

.time-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 8px;
  text-align: center;
}
</style>
